"use client"

import ChannelsList, {IChannel, useChannels} from "./chat/ChannelsList";
import Conversation from "./chat/Conversation";
import {useEffect, useState} from "react";
import {Box, Container, Flex, Heading} from "@radix-ui/themes";
import SafeRouter from "../utilities/SafeRouter";
import {MessagingListRulesQuery} from "../modals/Messaging/MessagingListRules";

export function MessagingWrapper(props: {
    initialChannelId: number | null,
    initialChannels: IChannel[],
    totalChannels: number,
    recipientUsers: IUser[],
}) {
    const [currentChannel, setCurrentChannel] = useState<IChannel | undefined>(props.initialChannels.find(channel => channel.id === props.initialChannelId));

    const [recipientUsers, setRecipientUsers] = useState<IUser[]>(props.recipientUsers);
    const [recipientRules, setRecipientRules] = useState<MessagingListRulesQuery[]>([]);

    const [showConversation, setShowConversation] = useState(!!(currentChannel?.id || recipientUsers.length > 0));

    const allowReplies = currentChannel ? currentChannel.type === "message" : (recipientUsers.length > 0 || recipientRules.length > 0);

    const {mutate} = useChannels(props.initialChannels);

    useEffect(() => {
        // purge messaging-related queries after mount so they don't impact future actions
        SafeRouter.setQueries(["uid"], ["listId"], ["role"]);
    }, []);

    return <Container pb={"4"}>
        <Box py={"4"}>
            <Heading size={"7"}>Messaging</Heading>
        </Box>
        <Flex p={"1"} gapX={"2"} align={"stretch"} style={{margin: "0 auto"}} wrap={{
            initial: "wrap",
            md: "nowrap",
        }}>
            <ChannelsList
                currentChannel={currentChannel}
                initialChannels={props.initialChannels}
                setCurrentChannel={setCurrentChannel}
                totalChannels={props.totalChannels}
                showConversation={showConversation}
                setRecipientUsers={setRecipientUsers}
                setRecipientRules={setRecipientRules}
                setShowConversation={setShowConversation}
            />
            {showConversation && <Conversation
                setShowConversation={setShowConversation}
                key={currentChannel?.id}
                recipients={recipientUsers}
                recipientRules={recipientRules}
                setRecipientUsers={setRecipientUsers}
                setRecipientRules={setRecipientRules}
                currentChannel={currentChannel}
                setCurrentChannel={setCurrentChannel}
                allowReplies={allowReplies}
                mutateChannels={mutate}
            />}
        </Flex>
    </Container>
}